import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormListItem, Text } from 'shared/components'

import * as styles from './styles'

const SignOutComponent = ({ auth }) => {
  const [showConfirmation, setShowConfirmation] = useState(false)

  const handleLogoutClick = () => {
    setShowConfirmation(true)
  }

  const handleConfirmLogout = () => {
    setShowConfirmation(false)
    auth.signout()
  }

  const handleCancelLogout = () => {
    setShowConfirmation(false)
  }

  return (
    <>
      <FormListItem title="Log out" onClick={handleLogoutClick} />

      {/* Logout Confirmation Popup */}
      {showConfirmation && (
        <div css={styles.overlay}>
          <div css={styles.popup}>
            <div css={styles.popupContent}>
              <Text size={14} bold css={styles.title}>
                Log out<br />
              </Text>
              <Text size={12} css={styles.message}>
                Are you sure you want to<br />log out?
              </Text>
              <div css={styles.spacer}></div>
              <div css={styles.buttonContainer}>
                <button
                  css={[styles.button, styles.noButton]}
                  onClick={handleCancelLogout}
                >
                  <Text size={12} medium css={styles.noButtonText}>
                    No
                  </Text>
                </button>
                <button
                  css={[styles.button, styles.yesButton]}
                  onClick={handleConfirmLogout}
                >
                  <Text size={12} medium css={styles.yesButtonText}>
                    Yes
                  </Text>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

SignOutComponent.propTypes = {
  auth: PropTypes.shape(),
}

export default SignOutComponent
